// personalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: {
    heightCm: "",
    baseWeight: "",
    targetWeight: "",
    timeSpan: "",
    birthYear: "",
    sex: "",
    jobType: "",
    weeklyLightMin: 0,
    weeklyHeavyMin: 0
  },
  sprint: null,
  byDate: {}
};

const personalSlice = createSlice({
  name: "personal",
  initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = { ...state.profile, ...action.payload };
    },
    setWeight(state, action) {
      const { date, weight } = action.payload;
      if (!state.byDate[date]) state.byDate[date] = {};
      state.byDate[date].weight = weight;
    },
    setLowActivity(state, action) {
      const { date, minutes } = action.payload;
      if (!state.byDate[date]) state.byDate[date] = {};
      state.byDate[date].lowActivityMin = minutes;
    },
    setHighActivity(state, action) {
      const { date, minutes } = action.payload;
      if (!state.byDate[date]) state.byDate[date] = {};
      state.byDate[date].highActivityMin = minutes;
    },
    startSprint(state, action) {
      state.sprint = action.payload;
    },
    stopSprint(state) {
      state.sprint = null;
    },
    setPersonalAll(state, action) {
      state.profile = action.payload.profile;
      state.sprint = action.payload.sprint;
      state.byDate = action.payload.byDate || {};
    },
  },
  // ✅ NEW
  extraReducers: (builder) => {
    builder.addCase("app/rehydrate", (state, action) => {
      if (action.payload?.profile) state.profile = action.payload.profile;
      if (action.payload?.byDate) state.byDate = action.payload.byDate;
    });
  },
});

export const {
  setProfile,
  setWeight,
  setLowActivity,
  setHighActivity,
  startSprint,
  stopSprint,
  setPersonalAll
} = personalSlice.actions;

export default personalSlice.reducer;